import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { styled } from 'styled-components';

const StyledTooltip = styled(Tooltip)<{ $maxWidth: number }>`
	word-break: break-word;
	max-width: ${({ $maxWidth }) => `${$maxWidth}px`};

	&.tooltip {
		background-color: ${({ theme }) => theme.colors.bgInfo};
		border-radius: ${({ theme }) => theme.borderRadii.md};
		color: ${({ theme }) => theme.colors.textDefault};
	}

	.tooltip-arrow {
		width: 16px;
		height: 16px;
		margin-bottom: -4px;
	}
`;

/* This is an alternative to the shared components Tooltip component for use inside a responsive side scrollable table. The stacked elements and overflow rules used for a side scrollable table 
   make using an absolute positioned tooltip (such as the one from shared components) difficult without causing the tooltip to clip when extending outside the bounds of the tables' 
   scrollable element.
*/
export const TableFriendlyTooltip: FC<{ id: string; maxWidth?: number }> = ({
	id,
	maxWidth = 240,
}) => (
	<StyledTooltip
		id={`${id}`}
		place="top"
		className="tooltip"
		classNameArrow="tooltip-arrow"
		offset={24}
		opacity={1}
		$maxWidth={maxWidth}
	/>
);
